<template>
  <div class="page-container" v-if="activeWorkflow.id && !incidentsLoading">
    <ul class="tabs">
      <li>
        <router-link :to="{ name: 'incidents' }">Reported Incidents</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'incident-reports' }" aria-selected="true">Incidents Summary</router-link>
      </li>
    </ul>
    <div class="page white">
      <div class="page__header page__header--large">
        <div class="actions">
          <themed-button :to="{ name: 'new-incident' }" class="page__action">New {{ workflowType() }}</themed-button>
        </div>
      </div>
      <number-of-incidents-per-month :incidents="incidents" />
    </div>

    <multiple-choice-questions :incidents="incidents" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import NumberOfIncidentsPerMonth from './report/NumberOfIncidentsPerMonth';
import MultipleChoiceQuestions from './report/MultipleChoiceQuestions';

export default {
  name: 'incident-reports',

  components: { NumberOfIncidentsPerMonth, MultipleChoiceQuestions },

  computed: {
    ...mapState({
      reportLoading: (state) => state.reportLoading,
    }),

    ...mapGetters(['incidentsFromPastMonths', 'activeWorkflow', 'workflowType']),

    incidents() {
      return this.incidentsFromPastMonths(12);
    },

    incidentsLoading() {
      return this.reportLoading.includes('incidents');
    },
  },

  watch: {
    activeWorkflow: {
      handler() {
        if (this.activeWorkflow.id) {
          this.fetchIncidents({ dependsOn: this.activeWorkflow.id, withData: true });
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions(['fetchIncidents']),
  },
};
</script>
